// To use randomBytes in mobile browser: https://github.com/tradle/rn-nodeify/issues/70
// This is used for the flows that we need to generate a random KSUID for the dynamoStreamMachine
// Entity ID.
import 'react-native-get-random-values';
import { registerRootComponent } from 'expo';

import App from "./app/app.tsx";
console.disableYellowBox = true;

let RootComponent = App;
export default registerRootComponent(RootComponent);